var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1014 342.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #0994f2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0.2,
    width: 1014,
    height: 342.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.5,233.5c-12.6,17.1-59.2-8.2-64.6-24.8,26-12.3,17.5-34.3,5.3-35.3-16.5-1.5-40.3,25.9-43.7,68.5-2.9,36.7,20.4,54.3,50.5,52.8,29.6-1.9,61.2-16.1,82.1-58.8,2.9-6.9,23.3,7.4,20.9,11.3-39.3,75.9-92.7,93.9-146,92C36.4,337.3-1,297.2,0,246.3c1.5-64.1,54.4-119.9,132.1-118.9,70.4,1,89.3,56.5,51.5,106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.4,274.8c5.8-24.8,12.2-49.5,19.2-74.2,6.3-22.4,6.8-70.1,34.3-74.5,6.3-1,65.6.5,61.5,14.7-16,56.2-31.1,100.2-35.9,126.8-2.9,18.7-.5,28.4,5.8,28.4,17,.5,46.1-23,62.6-58.8,2.9-6.9,23.3,7.4,20.9,11.8-22.3,42.1-59.7,89.1-115.1,91.5-51.9,2.4-62.6-25.9-53.4-65.6v-.2ZM260.7,60.5c4.9-23,23.3-41.1,49-40.6,25.2.5,38.4,18.5,34.5,40.6-3.9,22.4-21.8,40.6-50.5,40.6s-37.4-19-33-40.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.6,192.5c-4.9,20-15.5,49.3-20.4,71.9-3.9,18.2-1.5,31.3,7.3,31.3,18,0,42.2-27.4,57.3-58.8,3.4-6.9,23.3,6.9,20.9,11.8-19.4,37.2-57.3,90.4-112.2,92-50,1.5-61.2-26.4-51.5-65.1,3.9-15.2,16-65.1,18-73.8,2.9-13.2,2.9-21.6-10.7-19.5-10.2,1.5-21.8,8.7-34.5,19-14.1,45.9-22.3,86.2-33.5,131-8.2,11.8-72.3,14.2-78.2-2.9,12.9-57.2,29.4-113.6,46.4-169.7,2.9-9.8,4.4-25.4,12.9-31,5.8-3.8,16.7-3.6,23.3-3.8,4.4,0,49.3,4.3,45.4,14.6-2.9,7.9-4.9,16.6-7.8,24.5,17.5-13.7,48.6-37.2,77.7-36.7,37.9.5,48.6,26.4,39.3,65.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M747.6,234.5c-12.6,17.1-59.2-8.2-64.6-24.8,26-12.3,17.5-34.3,5.3-35.3-16.5-1.5-40.3,25.9-43.7,68.5-2.9,36.7,20.4,54.3,50.5,52.8,29.6-1.9,61.2-16.1,82.1-58.8,2.9-6.9,23.3,7.4,20.9,11.3-39.3,75.9-92.7,93.9-146,92-51.5-1.9-88.9-42.1-87.9-92.8,1.5-64.1,54.4-119.9,132.1-118.9,70.4,1,89.3,56.5,51.5,106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M920.3,17.5c-9.2,27.9-26.7,84.1-41.8,142.3,18-13.7,47.6-32.2,74.8-32.2,42.7,0,52,26.9,40.3,65.1-9.7,31.9-40.8,93.7-15.3,102.9,8.5,3.1,15.3,3.6,28.2-7.7,4.1-3.8,9.4-.5,6.5,4.3-13.9,30.7-37.7,48.1-69.4,48.5-49.6.5-57.3-25.4-53.4-54.8,3.4-25,19.4-75.4,22.3-84.1,4.4-12.7,3.4-22.4-10.2-21.1-9.2,1-23.8,9.2-35.9,20.6-13.1,49.3-24.8,93.3-34,131.5-2.4,10.8-86.4,17.1-80.6-5,27.2-103.1,68-244.9,91.3-322.4,17-11.6,78.2-3.4,77.2,11.8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4577cfdc34b5cf0f6abd77beb7a9430c.svg";
export { ForwardRef as ReactComponent };